import React from 'react';
import './App.css'; // or BeautyOfSriLanka.css
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const images = [
  '/images/Photo/S1.webp',
  '/images/Photo/S2.webp',
  '/images/Photo/S3.webp',
  '/images/Photo/S4.webp',
  '/images/Photo/S5.webp',
  '/images/Photo/S6.webp',
  '/images/Photo/S7.webp',
  '/images/Photo/S8.webp',
  '/images/Photo/S9.webp',
  '/images/Photo/S10.webp',
  '/images/Photo/S11.webp',
  '/images/Photo/S12.webp',
  '/images/Photo/S13.webp',
  '/images/Photo/S14.webp',
  '/images/Photo/S15.webp',
  '/images/Photo/S16.webp',
  '/images/Photo/S17.webp',
  '/images/Photo/S18.webp',
  '/images/Photo/S19.webp',
];

const filteredImages = images.filter((img) => img && typeof img === 'string');

const BeautyOfSriLanka = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,               // Auto slide enabled
    autoplaySpeed: 2000,          // Slide every 3 seconds
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <div className="beauty-container">
      <h2 className="beauty-heading">Beauty of Sri Lanka</h2>
      <Slider {...settings}>
        {filteredImages.map((src, index) => (
          <div key={index} className="image-slide">
            <img
              src={process.env.PUBLIC_URL + src}

              className="beauty-image"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BeautyOfSriLanka;
